import { defineComponent, onMounted, nextTick } from 'vue'
import MapPage from '@/organizations/_default/map'
import MapService from '@/services/MapService.ts'

// ズームレベルを+1する都道府県（SLv1の設定を踏襲、先方の指定）
const zoomPlusPrefs = ['茨城県', '埼玉県', '群馬県']
const maxZoom = 14

export default defineComponent({
  extends: MapPage,
  setup(props, context) {
    const page = MapPage.setup(props, context)

    onMounted(() => {
      nextTick(() => {
        // パラメータで都道府県が指定されている場合の位置・ズーム調整
        if (storelocator.beisia && storelocator.beisia.target_pref_locations.length) {

          const bounds = new google.maps.LatLngBounds()
          storelocator.beisia.target_pref_locations.forEach(loc => {
            const latLng = new google.maps.LatLng(loc.lat, loc.lng)
            bounds.extend(latLng)
          })
          
          MapService.map.fitBounds(bounds)

          // fitBoundes後にズームレベル調整
          google.maps.event.addListenerOnce(MapService.map, 'bounds_changed', () => {
            const currentZoom = MapService.map.getZoom()
            // 特定の都道府県はズームを+1
            if (zoomPlusPrefs.includes(storelocator.beisia.target_pref)) {
              MapService.map.setZoom(currentZoom + 1)
            }
            // 最大ズームレベル以下に調整
            if (currentZoom > maxZoom) {
              MapService.map.setZoom(maxZoom)
            }

          })
        }
      })
    })

    return page
  }
})
